import { Flipper as FASTFlipper } from '@microsoft/fast-components';
import { foundationFlipperStyles as styles } from './flipper.styles';
import { foundationFlipperTemplate as template } from './flipper.template';
/**
 * @tagname %%prefix%%-flipper
 */
export class Flipper extends FASTFlipper {
}
// explicitly declaring for extensibility
export const foundationFlipperShadowOptions = undefined;
export const defaultFlipperConfig = {
    next: `
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.023 15.273L11.29 8 4.023.727l.704-.704L12.71 8l-7.984 7.977-.704-.704z"
      />
    </svg>
  `,
    previous: `
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.273 15.977L3.29 8 11.273.023l.704.704L4.71 8l7.266 7.273-.704.704z"
      />
    </svg>
  `,
};
/**
 * The Foundation Flipper
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-flipper\>
 */
export const foundationFlipper = Flipper.compose(Object.assign({ baseName: 'flipper', template,
    styles, shadowOptions: foundationFlipperShadowOptions }, defaultFlipperConfig));
